import MultilanguagePlaceholder from '@/shared/assets/images/multilanguage.png';
import { MULTILANGUAGE_DOC_LINK } from '@/shared/constants/docLinks';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { LimitedFeatureContent, ModalContent } from '../types';
import { getBullets } from './bullets';
import { BULLETS_HEADER_TEXT, BUTTON_TEXTS } from './texts';

const BASE_CONTENT: ModalContent = {
  title: 'Unlock Multi-language translation feature',
  bulletsHeader: BULLETS_HEADER_TEXT.inCreator,
  buttonText: BUTTON_TEXTS.toBusiness,
  caption: `(Learn more)[${MULTILANGUAGE_DOC_LINK}] how to effectively utilize this feature`,
  features: getBullets([
    'translate500',
    'lipSync',
    'voiceCloneSettings',
    'voicePresets',
    'glossary',
    'srtUploadDownload',
    'subtitles',
    'aiRewrite',
    'simultaneousMultiLanguageTranslation',
    'api',
    'noWatermark',
  ]),
  media: {
    src: MultilanguagePlaceholder,
    type: 'image',
  },
  mixpanelButtonClickEvent: MixpanelEvents.multilanguageUpgradeChoosePlanModalClick,
  mixpanelOpeningEvent: MixpanelEvents.multilanguageUpgradeModalShown,
  subtitle:
    'Your plan allows translation to 1 language per upload. Upgrade to translate your video into multiple languages',
};

const TRIAL_PLAN_CONTENT = {
  ...BASE_CONTENT,
  bulletsHeader: BULLETS_HEADER_TEXT.withBusiness,
  subtitle:
    "You've reached your free videos limit. Upgrade to Business plan to translate your videos into multiple languages",
};

const STARTER_PLAN_CONTENT = {
  ...BASE_CONTENT,
  bulletsHeader: BULLETS_HEADER_TEXT.inTrial,
};

const CREATOR_PLAN_CONTENT = {
  ...BASE_CONTENT,
  features: getBullets([
    'translate500',
    'lipSync',
    'voiceCloneSettings',
    'voicePresets',
    'glossary',
    'srtUploadDownload',
    'subtitles',
    'aiRewrite',
    'simultaneousMultiLanguageTranslation',
    'api',
  ]),
};

const CREATOR_PRO_PLAN_CONTENT = {
  ...CREATOR_PLAN_CONTENT,
  bulletsHeader: BULLETS_HEADER_TEXT.inCreatorPro,
  features: getBullets(['translate500', 'glossary', 'voicePresets10', 'simultaneousMultiLanguageTranslation', 'api']),
};

export const MULTILANGUAGE_CONTENT: LimitedFeatureContent = {
  creator: CREATOR_PLAN_CONTENT,
  creatorPro: CREATOR_PRO_PLAN_CONTENT,
  starter: STARTER_PLAN_CONTENT,
  trial: TRIAL_PLAN_CONTENT,
};
